import {
  getSenderDetails as publicGetSenderDetails,
  updateSenderDetails as publicUpdateSenderDetails,
  verifyEmail as publicVerifyEmail,
  resolveActualFromAddress as publicResolveActualFromAddress,
} from './email-marketing-v1-sender-details-sender-details.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onSenderDetailsUpdated as publicOnSenderDetailsUpdated } from './email-marketing-v1-sender-details-sender-details.public.js';

export const getSenderDetails: MaybeContext<
  BuildRESTFunction<typeof publicGetSenderDetails> &
    typeof publicGetSenderDetails
> = /*#__PURE__*/ createRESTModule(publicGetSenderDetails);
export const updateSenderDetails: MaybeContext<
  BuildRESTFunction<typeof publicUpdateSenderDetails> &
    typeof publicUpdateSenderDetails
> = /*#__PURE__*/ createRESTModule(publicUpdateSenderDetails);
export const verifyEmail: MaybeContext<
  BuildRESTFunction<typeof publicVerifyEmail> & typeof publicVerifyEmail
> = /*#__PURE__*/ createRESTModule(publicVerifyEmail);
export const resolveActualFromAddress: MaybeContext<
  BuildRESTFunction<typeof publicResolveActualFromAddress> &
    typeof publicResolveActualFromAddress
> = /*#__PURE__*/ createRESTModule(publicResolveActualFromAddress);
/**
 * An event that triggers when sender details are updated without the need for explicit verification.
 */
export const onSenderDetailsUpdated: BuildEventDefinition<
  typeof publicOnSenderDetailsUpdated
> &
  typeof publicOnSenderDetailsUpdated = createEventModule(
  publicOnSenderDetailsUpdated
);

export { WebhookIdentityType } from './email-marketing-v1-sender-details-sender-details.universal.js';
export {
  SenderDetails,
  GetSenderDetailsRequest,
  GetSenderDetailsResponse,
  UpdateSenderDetailsRequest,
  UpdateSenderDetailsResponse,
  VerifySenderEmailRequest,
  VerifySenderEmailResponse,
  ResolveActualFromAddressRequest,
  ResolveActualFromAddressResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  SenderDetailsUpdatedEnvelope,
} from './email-marketing-v1-sender-details-sender-details.universal.js';
export {
  WebhookIdentityTypeWithLiterals,
  VerifyEmailApplicationErrors,
} from './email-marketing-v1-sender-details-sender-details.universal.js';
